var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "text-left mb-3" },
    [
      _c(
        "div",
        { staticClass: "d-flex align-items-center mb-2" },
        [
          _c("font-awesome-icon", {
            staticClass: "mr-2 icon-chevron",
            attrs: { icon: "chevron-right" },
          }),
          _c("v-label", { staticClass: "label-input" }, [
            _vm._v(_vm._s(_vm.label)),
          ]),
        ],
        1
      ),
      _c("v-text-field", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: _vm.rules,
            expression: "rules",
          },
        ],
        attrs: {
          name: _vm.name,
          "data-vv-as": (_vm.label || "").replace("*", "").trim(),
          value: _vm.value,
          outlined: "",
          dense: "",
          loading: _vm.loading,
          disabled: _vm.disabled,
        },
        on: {
          input: function ($event) {
            return _vm.$emit("input", $event)
          },
        },
      }),
      _c("span", { staticClass: "red--text" }, [
        _vm._v(_vm._s(_vm.validationErrors.first(_vm.name))),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }